import { createContext, useContext } from 'react';
import { useActor } from '@xstate/react';
export const Context = createContext(undefined);
export const { Provider: ApiProvider } = Context;
const useApiMachine = () => {
    const actorRef = useContext(Context);
    return useActor(actorRef);
};
export default useApiMachine;
